/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 */
import { connect } from 'react-redux';
import { hideModal } from '../../../actions/actions';
import ReportsModal from './reports.modal';
import { fetchReportCSV, clearCSV } from '../../../actions/study.details.actions';

const mapStateToProps = (state, ownProps) => {
  return {
    sites: ownProps.sites,
    studyGid: state.participants.studyGid,
    study: state.subject.participantStudy,
    isFetching: state.reports.isFetching,
    error: state.reports.error,
    user: state.login.user
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    close: () => {
      dispatch(hideModal());
      dispatch(clearCSV());
    },
    downloadReportCSV: (protocolNr, payload) => dispatch(fetchReportCSV(protocolNr, payload)),
    clearReportCSV: () => {
      dispatch(clearCSV());
    }
  };
};

const ReportsModalContainer = connect(mapStateToProps, mapDispatchToProps)(ReportsModal);

export default ReportsModalContainer;
